import React from 'react'
import Header from '../component/header/header'
import About from '../component/about/about'
import Footer from '../component/footer/footer'

const Aboutpage = () => {
    return (
        <>
            <Header />
            <About />
            <Footer />
        </>
    )
}

export default Aboutpage